import { SwitchField as CssModulesSwitchField, SwitchFieldProps } from '@sunwebgroup/uds-ui/fields/switch-field'
import { styled } from 'styled-components'

/**
 * @deprecated This component is deprecated and exists only to provide backward compatibility for code that previously relied on styled-components. Please use the corresponding component from '@sunwebgroup/uds-ui/fields/switch-field' instead.
 */
export default Object.assign(
  styled(CssModulesSwitchField)<SwitchFieldProps>``,
  { displayName: 'SwitchField' },
)
